import {
  lazy,
} from 'react'
import { CustomSuspense } from '../../components/CustomSuspense'

const LazyJobs = lazy(() => import('../Jobs'))

export const Jobs = (props) => (
  <CustomSuspense>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <LazyJobs {...props} />
  </CustomSuspense>
)
